<template>
  <div class="footerPC">
    <div class="left">
      <img class="left__img" src="@/assets/images/logo2.png" alt />
    </div>

    <!-- <ul class="center">
      <li v-for="(item, index) in chainList" :key="index" class="center__li">
        {{item.text}}
      </li>
    </ul> -->

    <ul class="right">
      <li v-for="(item, index) in imgList" :key="index" class="right__li">
        <img class="right__img" :src="item.img" alt />
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["black"],
  data() {
    return {
      chainList: [
        {
          text: "以太坊",
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
        {
          text: "比特币",
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
        {
          text: "Solana",
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
        {
          text: "Ton",
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
        {
          text: "Contact",
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
      ],
      imgList: [
        {
          img: require("@/assets/images/footer_icon1.png"),
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
        {
          img: require("@/assets/images/footer_icon2.png"),
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
        {
          img: require("@/assets/images/footer_icon3.png"),
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
        {
          img: require("@/assets/images/footer_icon4.png"),
          url: "https://opensea.io/collection/squirrel-wykoabwwab",
        },
      ],
    };
  },
  methods: {
    changeIndex(index) {
      this.imgList[index].show = !this.imgList[index].show;
    },
    changeIndexBack(index) {
      this.imgList[index].show = !this.imgList[index].show;
    },
  },
};
</script>

<style lang="scss" scoped>
.footerPC {
  width: 100%;
  min-width: 1200px;
  height: 120px;
  background: #191919;
  // position: fixed;
  // z-index: 110;
  bottom: 0;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 7% 0 7%; 

  .left {
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #191919;
    &__img {
      width: 244px;
      height: 61px;
      object-fit: contain;
    }
  }

  .center {
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    
    font-weight: normal;
    font-size: 14px;
    color: #B2B2B2;
    line-height: 20px;
    text-align: left;
    font-style: normal;
    text-transform: none;

    &__li {
      margin: 0 0 0 59px;
      cursor: pointer;
    }
  }

  .right {
    width: auto;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;

    &__li {
      margin: 0 0 0 59px;
    }

    &__img {
      width: 47px;
      height: 47px;
      object-fit: contain;
      cursor: pointer;
    }
  }
}
</style>